import { useState } from "react"
import axios from 'axios'
import { useToast } from "../../toastHook"

export const DailyJobsComponent = () => {
    const { display } = useToast();
    const [doOnceDailyJob, setDoOnceDailyJob] = useState(false);
    const [launchWordEngineResult, setLaunchWordEngineResult] = useState(null);
    const launchDailyJob = () => {

        if (doOnceDailyJob) {
            return;
        }

        setDoOnceDailyJob(true);

        axios.get("/api/dcgenjob/importskills")
            .then(
                response => {
                    display({
                        titre: "le job d'import des skills dcgen a démarré",
                        text: "le job d'import des skills dcgen a démarré, suivez le job dans l'écran de monitoring",
                        severity: 'success'
                    });
                }
            )
    }

    const launchTestWordEngine = () => {
        axios.get("/api/dcgenjob/testengine")
            .then(
                response => setLaunchWordEngineResult(response.data)
            );
    }

    let resultWordEngine = <></>;
    if (launchWordEngineResult) {
        if (launchWordEngineResult.isSuccess) {
            resultWordEngine = <div className="alert alert-success">Le word engine peut se loader</div>
        }
        else {
            resultWordEngine = <div className="alert alert-danger">Le word engine ne peut pas se loader, raison = { launchWordEngineResult.errorMessage }</div>
        }
    }

    return <div>
        <div className="card">
            <div className="card-header">
                Import des sonar skills dcgen
            </div>
            <div className="card-body">
                <div className="alert alert-primary">Le job d'import de skill importe les skills de dcgen comme compétence similaire, pour le lancer <button onClick={() => launchDailyJob()} className="btn  btn-outline-primary">Cliquez ici</button></div>
                <div>
                    <p>Vous pouvez voir s'il y a un problème de load de l'engine en <button onClick={() => launchTestWordEngine()} className="btn  btn-outline-primary">Cliquant ici</button></p>
                    { resultWordEngine }
                </div>
            </div>
        </div>
        </div>
}





